import { Button } from '@mui/material';
import { Box } from '@smartfm/ui/components/Box';
import { Typography } from '@smartfm/ui/components/Typography';

interface NoWidgetsStateProps {
  onSetupWidgets: () => void;
}

export function NoWidgetsState(props: NoWidgetsStateProps) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {/* Take into account only the picture size for centering */}
      <Box sx={{ width: '304px', whiteSpace: 'nowrap' }}>
        <img
          src='/edit-dashboard.png'
          width='304'
          style={{ marginBottom: '12px' }}
        />

        <Box sx={{ paddingBottom: 1 }}>
          <Typography variant='Calibre/H6 Headline'>
            Let’s set up your dashboard
          </Typography>
        </Box>
        <Box sx={{ paddingBottom: 1 }}>
          <Typography variant='Calibre/Body 2'>
            You can add, resize and rearrange widgets to your preference.
          </Typography>
        </Box>

        <Button
          id='admin-add-new-user'
          variant='contained'
          sx={{
            backgroundColor: '#003f2d',
            color: '#ffffff',
            padding: '12px 16px 12px 16px',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            textTransform: 'none',
            letterSpacing: 0,
            boxShadow: 'none',
            width: 'fit-content',
          }}
          onClick={props.onSetupWidgets}
        >
          Setup dashboard
        </Button>
      </Box>
    </Box>
  );
}
